export default "__VITE_ASSET__Dezm4BJg__"